import React from 'react';
import './Terms.css';

function Terms() {
  return (
    <section className="terms-page">
      <div className="container">
        <header>
          <h1>Terms of Service</h1>
        </header>
        <main className="terms-content">
          <p className="last-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          <article>
            <h2>1. Overview</h2>
            <p>
              Welcome to SheetPilot ("we", "our", or "us"). These Terms of Service ("Terms") govern your access to and use of our online course and related digital content (the "Service"). By purchasing or accessing the Service, you agree to be bound by these Terms.
            </p>

            <h2>2. Digital Product - No Refund Policy</h2>
            <p>
              The Service is a digital educational product consisting of video content and instructional materials. <strong>All sales are final. We do not offer refunds or exchanges under any circumstances once the digital content has been accessed or downloaded.</strong>
            </p>
            <p>
              By completing your purchase, you acknowledge and agree that:
            </p>
            <ul>
              <li>You understand that this is a non-tangible, virtual product</li>
              <li>You waive any right to cancel or refund once access is granted</li>
              <li>No exceptions will be made to this policy</li>
            </ul>

            <h2>3. Payment</h2>
            <p>
              All payments are processed securely through <strong>Stripe</strong>, a third-party payment service provider. By using the Service, you agree to:
            </p>
            <ul>
              <li>Pay the fees displayed at checkout ($10 USD, unless otherwise stated)</li>
              <li>Provide accurate and complete payment information</li>
              <li>Authorize us to charge your payment method via Stripe</li>
            </ul>
            <p>
              We do not store your credit card or payment information on our servers. All payment data is handled directly by Stripe in accordance with their terms and privacy policy.
            </p>

            <h2>4. License to Use</h2>
            <p>
              Upon full payment, you are granted a limited, non-exclusive, non-transferable, lifetime license to access the course content for your personal, non-commercial use only. You may not:
            </p>
            <ul>
              <li>Resell, redistribute, or share the course content</li>
              <li>Use the content for commercial purposes without our written consent</li>
              <li>Record, copy, or reproduce any part of the course</li>
            </ul>

            <h2>5. No Professional Guarantee</h2>
            <p>
              The Service is provided for educational purposes only. We do not guarantee any specific results, outcomes, or proficiency level from using the Service. Your results depend on your own effort, dedication, and prior knowledge.
            </p>

            <h2>6. Third-Party Tools</h2>
            <p>
              This course teaches the use of Mica, a third-party AI tool for Excel. We are not affiliated with, endorsed by, or responsible for Mica or any other third-party software mentioned in the course.
            </p>

            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of the Service after any changes constitutes acceptance of the new Terms.
            </p>

            <h2>8. Contact Information</h2>
            <p>
              If you have any questions about these Terms, please contact us at: <strong>support@mindlink.work</strong>
            </p>

            <h2>9. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the seller operates, without regard to its conflict of law provisions.
            </p>
          </article>
        </main>
      </div>
    </section>
  );
}

export default Terms;
